// This file is auto-generated by @hey-api/openapi-ts

import { type DefaultError, type InfiniteData, infiniteQueryOptions, queryOptions, type UseMutationOptions } from '@tanstack/react-query';

import { client } from '../client.gen';
import { adminAddHomeNetwork, adminClearDeviceBrowsingActivity, adminClearDeviceWindowCaptures, adminConfirmFilteringRule, adminCreateDevice, adminCreateFamily, adminCreateParent, adminDeleteDevice, adminDeleteDeviceScreenshots, adminDeleteFamily, adminDeleteFilteringRule, adminDeleteHomeNetwork, adminDeleteParent, adminDeviceBrowsingActivity, adminDeviceDetail, adminDeviceScreenshots, adminDeviceWindowCaptures, adminFamilyDetail, adminGenerateFilteringRule, adminGetDeploymentSettings, adminListAgentBundles, adminListCommands, adminListExtensionReleases, adminListFamilies, adminListFilteringRules, adminListHomeNetworks, adminListModuleRegistry, adminListModules, adminQueueCommand, adminReadFilteringRule, adminScreenshotImage, adminSetFilteringRuleEnabled, adminSetModule, adminSetTargetVersion, adminUpdateDeploymentSettings, adminUpdateDevice, adminUpdateFamily, adminUpdateParent, adminUploadAgentBundle, adminUploadExtensionRelease, adminWindowCapture, deviceActivity, deviceAgentBundle, deviceCapturesUpload, deviceDeviceCaptureV2Config, deviceDeviceConfig, deviceDownloadFile, deviceExtensionCrx, deviceExtensionUpdatesXml, deviceHeartbeat, deviceScreenshotsLive, deviceScreenshotsUpload, metaHealth, type Options, parentAuthChangePassword, parentAuthLogin, parentAuthLogout, parentAuthMe, parentReadDeviceDetail, parentReadDevices, parentReadDeviceScreenshots, parentReadFamily, parentReadScreenshotImage, parentReadScreenshotThumbnail, parentRulesConfirm, parentRulesDelete, parentRulesGenerate, parentRulesList, parentRulesRead, parentRulesSetEnabled } from '../sdk.gen';
import type { AdminAddHomeNetworkData, AdminAddHomeNetworkError, AdminAddHomeNetworkResponse, AdminClearDeviceBrowsingActivityData, AdminClearDeviceBrowsingActivityError, AdminClearDeviceBrowsingActivityResponse, AdminClearDeviceWindowCapturesData, AdminClearDeviceWindowCapturesError, AdminClearDeviceWindowCapturesResponse, AdminConfirmFilteringRuleData, AdminConfirmFilteringRuleError, AdminConfirmFilteringRuleResponse, AdminCreateDeviceData, AdminCreateDeviceError, AdminCreateDeviceResponse, AdminCreateFamilyData, AdminCreateFamilyError, AdminCreateFamilyResponse, AdminCreateParentData, AdminCreateParentError, AdminCreateParentResponse, AdminDeleteDeviceData, AdminDeleteDeviceError, AdminDeleteDeviceResponse, AdminDeleteDeviceScreenshotsData, AdminDeleteDeviceScreenshotsError, AdminDeleteDeviceScreenshotsResponse, AdminDeleteFamilyData, AdminDeleteFamilyError, AdminDeleteFamilyResponse, AdminDeleteFilteringRuleData, AdminDeleteFilteringRuleError, AdminDeleteFilteringRuleResponse, AdminDeleteHomeNetworkData, AdminDeleteHomeNetworkError, AdminDeleteHomeNetworkResponse, AdminDeleteParentData, AdminDeleteParentError, AdminDeleteParentResponse, AdminDeviceBrowsingActivityData, AdminDeviceBrowsingActivityError, AdminDeviceBrowsingActivityResponse, AdminDeviceDetailData, AdminDeviceDetailError, AdminDeviceDetailResponse, AdminDeviceScreenshotsData, AdminDeviceScreenshotsError, AdminDeviceScreenshotsResponse, AdminDeviceWindowCapturesData, AdminDeviceWindowCapturesError, AdminDeviceWindowCapturesResponse, AdminFamilyDetailData, AdminFamilyDetailError, AdminFamilyDetailResponse, AdminGenerateFilteringRuleData, AdminGenerateFilteringRuleError, AdminGenerateFilteringRuleResponse, AdminGetDeploymentSettingsData, AdminGetDeploymentSettingsError, AdminGetDeploymentSettingsResponse, AdminListAgentBundlesData, AdminListAgentBundlesError, AdminListAgentBundlesResponse, AdminListCommandsData, AdminListCommandsError, AdminListCommandsResponse, AdminListExtensionReleasesData, AdminListExtensionReleasesError, AdminListExtensionReleasesResponse, AdminListFamiliesData, AdminListFamiliesError, AdminListFamiliesResponse, AdminListFilteringRulesData, AdminListFilteringRulesError, AdminListFilteringRulesResponse, AdminListHomeNetworksData, AdminListHomeNetworksError, AdminListHomeNetworksResponse, AdminListModuleRegistryData, AdminListModuleRegistryError, AdminListModuleRegistryResponse, AdminListModulesData, AdminListModulesError, AdminListModulesResponse, AdminQueueCommandData, AdminQueueCommandError, AdminQueueCommandResponse, AdminReadFilteringRuleData, AdminReadFilteringRuleError, AdminReadFilteringRuleResponse, AdminScreenshotImageData, AdminScreenshotImageError, AdminSetFilteringRuleEnabledData, AdminSetFilteringRuleEnabledError, AdminSetFilteringRuleEnabledResponse, AdminSetModuleData, AdminSetModuleError, AdminSetModuleResponse, AdminSetTargetVersionData, AdminSetTargetVersionError, AdminSetTargetVersionResponse, AdminUpdateDeploymentSettingsData, AdminUpdateDeploymentSettingsError, AdminUpdateDeploymentSettingsResponse, AdminUpdateDeviceData, AdminUpdateDeviceError, AdminUpdateDeviceResponse, AdminUpdateFamilyData, AdminUpdateFamilyError, AdminUpdateFamilyResponse, AdminUpdateParentData, AdminUpdateParentError, AdminUpdateParentResponse, AdminUploadAgentBundleData, AdminUploadAgentBundleError, AdminUploadAgentBundleResponse, AdminUploadExtensionReleaseData, AdminUploadExtensionReleaseError, AdminUploadExtensionReleaseResponse, AdminWindowCaptureData, AdminWindowCaptureError, AdminWindowCaptureResponse, DeviceActivityData, DeviceActivityError, DeviceAgentBundleData, DeviceAgentBundleError, DeviceCapturesUploadData, DeviceCapturesUploadError, DeviceDeviceCaptureV2ConfigData, DeviceDeviceCaptureV2ConfigError, DeviceDeviceConfigData, DeviceDeviceConfigError, DeviceDownloadFileData, DeviceDownloadFileError, DeviceExtensionCrxData, DeviceExtensionCrxError, DeviceExtensionUpdatesXmlData, DeviceHeartbeatData, DeviceHeartbeatError, DeviceHeartbeatResponse, DeviceScreenshotsLiveData, DeviceScreenshotsUploadData, MetaHealthData, MetaHealthResponse, ParentAuthChangePasswordData, ParentAuthChangePasswordError, ParentAuthChangePasswordResponse, ParentAuthLoginData, ParentAuthLoginError, ParentAuthLoginResponse, ParentAuthLogoutData, ParentAuthLogoutResponse, ParentAuthMeData, ParentAuthMeError, ParentAuthMeResponse, ParentReadDeviceDetailData, ParentReadDeviceDetailError, ParentReadDeviceDetailResponse, ParentReadDeviceScreenshotsData, ParentReadDeviceScreenshotsError, ParentReadDeviceScreenshotsResponse, ParentReadDevicesData, ParentReadDevicesError, ParentReadDevicesResponse, ParentReadFamilyData, ParentReadFamilyError, ParentReadFamilyResponse, ParentReadScreenshotImageData, ParentReadScreenshotImageError, ParentReadScreenshotThumbnailData, ParentReadScreenshotThumbnailError, ParentRulesConfirmData, ParentRulesConfirmError, ParentRulesConfirmResponse, ParentRulesDeleteData, ParentRulesDeleteError, ParentRulesDeleteResponse, ParentRulesGenerateData, ParentRulesGenerateError, ParentRulesGenerateResponse, ParentRulesListData, ParentRulesListError, ParentRulesListResponse, ParentRulesReadData, ParentRulesReadError, ParentRulesReadResponse, ParentRulesSetEnabledData, ParentRulesSetEnabledError, ParentRulesSetEnabledResponse } from '../types.gen';

/**
 * Change Password
 */
export const parentAuthChangePasswordMutation = (options?: Partial<Options<ParentAuthChangePasswordData>>): UseMutationOptions<ParentAuthChangePasswordResponse, ParentAuthChangePasswordError, Options<ParentAuthChangePasswordData>> => {
    const mutationOptions: UseMutationOptions<ParentAuthChangePasswordResponse, ParentAuthChangePasswordError, Options<ParentAuthChangePasswordData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await parentAuthChangePassword({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Activity
 */
export const deviceActivityMutation = (options?: Partial<Options<DeviceActivityData>>): UseMutationOptions<unknown, DeviceActivityError, Options<DeviceActivityData>> => {
    const mutationOptions: UseMutationOptions<unknown, DeviceActivityError, Options<DeviceActivityData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deviceActivity({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const adminListAgentBundlesQueryKey = (options?: Options<AdminListAgentBundlesData>) => createQueryKey('adminListAgentBundles', options);

/**
 * List Agent Bundles
 */
export const adminListAgentBundlesOptions = (options?: Options<AdminListAgentBundlesData>) => queryOptions<AdminListAgentBundlesResponse, AdminListAgentBundlesError, AdminListAgentBundlesResponse, ReturnType<typeof adminListAgentBundlesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminListAgentBundles({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminListAgentBundlesQueryKey(options)
});

/**
 * Upload Agent Bundle
 */
export const adminUploadAgentBundleMutation = (options?: Partial<Options<AdminUploadAgentBundleData>>): UseMutationOptions<AdminUploadAgentBundleResponse, AdminUploadAgentBundleError, Options<AdminUploadAgentBundleData>> => {
    const mutationOptions: UseMutationOptions<AdminUploadAgentBundleResponse, AdminUploadAgentBundleError, Options<AdminUploadAgentBundleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUploadAgentBundle({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminGetDeploymentSettingsQueryKey = (options?: Options<AdminGetDeploymentSettingsData>) => createQueryKey('adminGetDeploymentSettings', options);

/**
 * Get Deployment Settings
 */
export const adminGetDeploymentSettingsOptions = (options?: Options<AdminGetDeploymentSettingsData>) => queryOptions<AdminGetDeploymentSettingsResponse, AdminGetDeploymentSettingsError, AdminGetDeploymentSettingsResponse, ReturnType<typeof adminGetDeploymentSettingsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminGetDeploymentSettings({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminGetDeploymentSettingsQueryKey(options)
});

/**
 * Update Deployment Settings
 */
export const adminUpdateDeploymentSettingsMutation = (options?: Partial<Options<AdminUpdateDeploymentSettingsData>>): UseMutationOptions<AdminUpdateDeploymentSettingsResponse, AdminUpdateDeploymentSettingsError, Options<AdminUpdateDeploymentSettingsData>> => {
    const mutationOptions: UseMutationOptions<AdminUpdateDeploymentSettingsResponse, AdminUpdateDeploymentSettingsError, Options<AdminUpdateDeploymentSettingsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUpdateDeploymentSettings({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Clear Device Browsing Activity
 */
export const adminClearDeviceBrowsingActivityMutation = (options?: Partial<Options<AdminClearDeviceBrowsingActivityData>>): UseMutationOptions<AdminClearDeviceBrowsingActivityResponse, AdminClearDeviceBrowsingActivityError, Options<AdminClearDeviceBrowsingActivityData>> => {
    const mutationOptions: UseMutationOptions<AdminClearDeviceBrowsingActivityResponse, AdminClearDeviceBrowsingActivityError, Options<AdminClearDeviceBrowsingActivityData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminClearDeviceBrowsingActivity({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminDeviceBrowsingActivityQueryKey = (options: Options<AdminDeviceBrowsingActivityData>) => createQueryKey('adminDeviceBrowsingActivity', options);

/**
 * Device Browsing Activity
 */
export const adminDeviceBrowsingActivityOptions = (options: Options<AdminDeviceBrowsingActivityData>) => queryOptions<AdminDeviceBrowsingActivityResponse, AdminDeviceBrowsingActivityError, AdminDeviceBrowsingActivityResponse, ReturnType<typeof adminDeviceBrowsingActivityQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminDeviceBrowsingActivity({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminDeviceBrowsingActivityQueryKey(options)
});

export const adminListCommandsQueryKey = (options: Options<AdminListCommandsData>) => createQueryKey('adminListCommands', options);

/**
 * List Commands
 */
export const adminListCommandsOptions = (options: Options<AdminListCommandsData>) => queryOptions<AdminListCommandsResponse, AdminListCommandsError, AdminListCommandsResponse, ReturnType<typeof adminListCommandsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminListCommands({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminListCommandsQueryKey(options)
});

/**
 * Queue Command
 */
export const adminQueueCommandMutation = (options?: Partial<Options<AdminQueueCommandData>>): UseMutationOptions<AdminQueueCommandResponse, AdminQueueCommandError, Options<AdminQueueCommandData>> => {
    const mutationOptions: UseMutationOptions<AdminQueueCommandResponse, AdminQueueCommandError, Options<AdminQueueCommandData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminQueueCommand({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminListFilteringRulesQueryKey = (options: Options<AdminListFilteringRulesData>) => createQueryKey('adminListFilteringRules', options);

/**
 * List Filtering Rules
 */
export const adminListFilteringRulesOptions = (options: Options<AdminListFilteringRulesData>) => queryOptions<AdminListFilteringRulesResponse, AdminListFilteringRulesError, AdminListFilteringRulesResponse, ReturnType<typeof adminListFilteringRulesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminListFilteringRules({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminListFilteringRulesQueryKey(options)
});

/**
 * Generate Filtering Rule
 */
export const adminGenerateFilteringRuleMutation = (options?: Partial<Options<AdminGenerateFilteringRuleData>>): UseMutationOptions<AdminGenerateFilteringRuleResponse, AdminGenerateFilteringRuleError, Options<AdminGenerateFilteringRuleData>> => {
    const mutationOptions: UseMutationOptions<AdminGenerateFilteringRuleResponse, AdminGenerateFilteringRuleError, Options<AdminGenerateFilteringRuleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminGenerateFilteringRule({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Filtering Rule
 */
export const adminDeleteFilteringRuleMutation = (options?: Partial<Options<AdminDeleteFilteringRuleData>>): UseMutationOptions<AdminDeleteFilteringRuleResponse, AdminDeleteFilteringRuleError, Options<AdminDeleteFilteringRuleData>> => {
    const mutationOptions: UseMutationOptions<AdminDeleteFilteringRuleResponse, AdminDeleteFilteringRuleError, Options<AdminDeleteFilteringRuleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminDeleteFilteringRule({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminReadFilteringRuleQueryKey = (options: Options<AdminReadFilteringRuleData>) => createQueryKey('adminReadFilteringRule', options);

/**
 * Read Filtering Rule
 */
export const adminReadFilteringRuleOptions = (options: Options<AdminReadFilteringRuleData>) => queryOptions<AdminReadFilteringRuleResponse, AdminReadFilteringRuleError, AdminReadFilteringRuleResponse, ReturnType<typeof adminReadFilteringRuleQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminReadFilteringRule({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminReadFilteringRuleQueryKey(options)
});

/**
 * Confirm Filtering Rule
 */
export const adminConfirmFilteringRuleMutation = (options?: Partial<Options<AdminConfirmFilteringRuleData>>): UseMutationOptions<AdminConfirmFilteringRuleResponse, AdminConfirmFilteringRuleError, Options<AdminConfirmFilteringRuleData>> => {
    const mutationOptions: UseMutationOptions<AdminConfirmFilteringRuleResponse, AdminConfirmFilteringRuleError, Options<AdminConfirmFilteringRuleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminConfirmFilteringRule({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Set Filtering Rule Enabled
 */
export const adminSetFilteringRuleEnabledMutation = (options?: Partial<Options<AdminSetFilteringRuleEnabledData>>): UseMutationOptions<AdminSetFilteringRuleEnabledResponse, AdminSetFilteringRuleEnabledError, Options<AdminSetFilteringRuleEnabledData>> => {
    const mutationOptions: UseMutationOptions<AdminSetFilteringRuleEnabledResponse, AdminSetFilteringRuleEnabledError, Options<AdminSetFilteringRuleEnabledData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminSetFilteringRuleEnabled({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Home Network
 */
export const adminDeleteHomeNetworkMutation = (options?: Partial<Options<AdminDeleteHomeNetworkData>>): UseMutationOptions<AdminDeleteHomeNetworkResponse, AdminDeleteHomeNetworkError, Options<AdminDeleteHomeNetworkData>> => {
    const mutationOptions: UseMutationOptions<AdminDeleteHomeNetworkResponse, AdminDeleteHomeNetworkError, Options<AdminDeleteHomeNetworkData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminDeleteHomeNetwork({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminListHomeNetworksQueryKey = (options: Options<AdminListHomeNetworksData>) => createQueryKey('adminListHomeNetworks', options);

/**
 * List Home Networks
 */
export const adminListHomeNetworksOptions = (options: Options<AdminListHomeNetworksData>) => queryOptions<AdminListHomeNetworksResponse, AdminListHomeNetworksError, AdminListHomeNetworksResponse, ReturnType<typeof adminListHomeNetworksQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminListHomeNetworks({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminListHomeNetworksQueryKey(options)
});

/**
 * Add Home Network
 */
export const adminAddHomeNetworkMutation = (options?: Partial<Options<AdminAddHomeNetworkData>>): UseMutationOptions<AdminAddHomeNetworkResponse, AdminAddHomeNetworkError, Options<AdminAddHomeNetworkData>> => {
    const mutationOptions: UseMutationOptions<AdminAddHomeNetworkResponse, AdminAddHomeNetworkError, Options<AdminAddHomeNetworkData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminAddHomeNetwork({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminListModulesQueryKey = (options: Options<AdminListModulesData>) => createQueryKey('adminListModules', options);

/**
 * List Modules
 */
export const adminListModulesOptions = (options: Options<AdminListModulesData>) => queryOptions<AdminListModulesResponse, AdminListModulesError, AdminListModulesResponse, ReturnType<typeof adminListModulesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminListModules({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminListModulesQueryKey(options)
});

/**
 * Set Module
 */
export const adminSetModuleMutation = (options?: Partial<Options<AdminSetModuleData>>): UseMutationOptions<AdminSetModuleResponse, AdminSetModuleError, Options<AdminSetModuleData>> => {
    const mutationOptions: UseMutationOptions<AdminSetModuleResponse, AdminSetModuleError, Options<AdminSetModuleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminSetModule({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Device Screenshots
 */
export const adminDeleteDeviceScreenshotsMutation = (options?: Partial<Options<AdminDeleteDeviceScreenshotsData>>): UseMutationOptions<AdminDeleteDeviceScreenshotsResponse, AdminDeleteDeviceScreenshotsError, Options<AdminDeleteDeviceScreenshotsData>> => {
    const mutationOptions: UseMutationOptions<AdminDeleteDeviceScreenshotsResponse, AdminDeleteDeviceScreenshotsError, Options<AdminDeleteDeviceScreenshotsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminDeleteDeviceScreenshots({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminDeviceScreenshotsQueryKey = (options: Options<AdminDeviceScreenshotsData>) => createQueryKey('adminDeviceScreenshots', options);

/**
 * Device Screenshots
 */
export const adminDeviceScreenshotsOptions = (options: Options<AdminDeviceScreenshotsData>) => queryOptions<AdminDeviceScreenshotsResponse, AdminDeviceScreenshotsError, AdminDeviceScreenshotsResponse, ReturnType<typeof adminDeviceScreenshotsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminDeviceScreenshots({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminDeviceScreenshotsQueryKey(options)
});

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = { ...queryKey[0] };
    if (page.body) {
        params.body = {
            ...queryKey[0].body as any,
            ...page.body as any
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path as any,
            ...page.path as any
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query as any,
            ...page.query as any
        };
    }
    return params as unknown as typeof page;
};

export const adminDeviceScreenshotsInfiniteQueryKey = (options: Options<AdminDeviceScreenshotsData>): QueryKey<Options<AdminDeviceScreenshotsData>> => createQueryKey('adminDeviceScreenshots', options, true);

/**
 * Device Screenshots
 */
export const adminDeviceScreenshotsInfiniteOptions = (options: Options<AdminDeviceScreenshotsData>) => infiniteQueryOptions<AdminDeviceScreenshotsResponse, AdminDeviceScreenshotsError, InfiniteData<AdminDeviceScreenshotsResponse>, QueryKey<Options<AdminDeviceScreenshotsData>>, number | Pick<QueryKey<Options<AdminDeviceScreenshotsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<AdminDeviceScreenshotsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                offset: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await adminDeviceScreenshots({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminDeviceScreenshotsInfiniteQueryKey(options)
});

/**
 * Set Target Version
 */
export const adminSetTargetVersionMutation = (options?: Partial<Options<AdminSetTargetVersionData>>): UseMutationOptions<AdminSetTargetVersionResponse, AdminSetTargetVersionError, Options<AdminSetTargetVersionData>> => {
    const mutationOptions: UseMutationOptions<AdminSetTargetVersionResponse, AdminSetTargetVersionError, Options<AdminSetTargetVersionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminSetTargetVersion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Clear Device Window Captures
 */
export const adminClearDeviceWindowCapturesMutation = (options?: Partial<Options<AdminClearDeviceWindowCapturesData>>): UseMutationOptions<AdminClearDeviceWindowCapturesResponse, AdminClearDeviceWindowCapturesError, Options<AdminClearDeviceWindowCapturesData>> => {
    const mutationOptions: UseMutationOptions<AdminClearDeviceWindowCapturesResponse, AdminClearDeviceWindowCapturesError, Options<AdminClearDeviceWindowCapturesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminClearDeviceWindowCaptures({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminDeviceWindowCapturesQueryKey = (options: Options<AdminDeviceWindowCapturesData>) => createQueryKey('adminDeviceWindowCaptures', options);

/**
 * Device Window Captures
 */
export const adminDeviceWindowCapturesOptions = (options: Options<AdminDeviceWindowCapturesData>) => queryOptions<AdminDeviceWindowCapturesResponse, AdminDeviceWindowCapturesError, AdminDeviceWindowCapturesResponse, ReturnType<typeof adminDeviceWindowCapturesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminDeviceWindowCaptures({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminDeviceWindowCapturesQueryKey(options)
});

export const adminDeviceWindowCapturesInfiniteQueryKey = (options: Options<AdminDeviceWindowCapturesData>): QueryKey<Options<AdminDeviceWindowCapturesData>> => createQueryKey('adminDeviceWindowCaptures', options, true);

/**
 * Device Window Captures
 */
export const adminDeviceWindowCapturesInfiniteOptions = (options: Options<AdminDeviceWindowCapturesData>) => infiniteQueryOptions<AdminDeviceWindowCapturesResponse, AdminDeviceWindowCapturesError, InfiniteData<AdminDeviceWindowCapturesResponse>, QueryKey<Options<AdminDeviceWindowCapturesData>>, number | Pick<QueryKey<Options<AdminDeviceWindowCapturesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<AdminDeviceWindowCapturesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                offset: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await adminDeviceWindowCaptures({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminDeviceWindowCapturesInfiniteQueryKey(options)
});

export const adminListExtensionReleasesQueryKey = (options?: Options<AdminListExtensionReleasesData>) => createQueryKey('adminListExtensionReleases', options);

/**
 * List Extension Releases
 */
export const adminListExtensionReleasesOptions = (options?: Options<AdminListExtensionReleasesData>) => queryOptions<AdminListExtensionReleasesResponse, AdminListExtensionReleasesError, AdminListExtensionReleasesResponse, ReturnType<typeof adminListExtensionReleasesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminListExtensionReleases({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminListExtensionReleasesQueryKey(options)
});

/**
 * Upload Extension Release
 */
export const adminUploadExtensionReleaseMutation = (options?: Partial<Options<AdminUploadExtensionReleaseData>>): UseMutationOptions<AdminUploadExtensionReleaseResponse, AdminUploadExtensionReleaseError, Options<AdminUploadExtensionReleaseData>> => {
    const mutationOptions: UseMutationOptions<AdminUploadExtensionReleaseResponse, AdminUploadExtensionReleaseError, Options<AdminUploadExtensionReleaseData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUploadExtensionRelease({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminListFamiliesQueryKey = (options?: Options<AdminListFamiliesData>) => createQueryKey('adminListFamilies', options);

/**
 * List Families
 */
export const adminListFamiliesOptions = (options?: Options<AdminListFamiliesData>) => queryOptions<AdminListFamiliesResponse, AdminListFamiliesError, AdminListFamiliesResponse, ReturnType<typeof adminListFamiliesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminListFamilies({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminListFamiliesQueryKey(options)
});

/**
 * Create Family
 */
export const adminCreateFamilyMutation = (options?: Partial<Options<AdminCreateFamilyData>>): UseMutationOptions<AdminCreateFamilyResponse, AdminCreateFamilyError, Options<AdminCreateFamilyData>> => {
    const mutationOptions: UseMutationOptions<AdminCreateFamilyResponse, AdminCreateFamilyError, Options<AdminCreateFamilyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminCreateFamily({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Family
 */
export const adminDeleteFamilyMutation = (options?: Partial<Options<AdminDeleteFamilyData>>): UseMutationOptions<AdminDeleteFamilyResponse, AdminDeleteFamilyError, Options<AdminDeleteFamilyData>> => {
    const mutationOptions: UseMutationOptions<AdminDeleteFamilyResponse, AdminDeleteFamilyError, Options<AdminDeleteFamilyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminDeleteFamily({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminFamilyDetailQueryKey = (options: Options<AdminFamilyDetailData>) => createQueryKey('adminFamilyDetail', options);

/**
 * Family Detail
 */
export const adminFamilyDetailOptions = (options: Options<AdminFamilyDetailData>) => queryOptions<AdminFamilyDetailResponse, AdminFamilyDetailError, AdminFamilyDetailResponse, ReturnType<typeof adminFamilyDetailQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminFamilyDetail({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminFamilyDetailQueryKey(options)
});

/**
 * Update Family
 */
export const adminUpdateFamilyMutation = (options?: Partial<Options<AdminUpdateFamilyData>>): UseMutationOptions<AdminUpdateFamilyResponse, AdminUpdateFamilyError, Options<AdminUpdateFamilyData>> => {
    const mutationOptions: UseMutationOptions<AdminUpdateFamilyResponse, AdminUpdateFamilyError, Options<AdminUpdateFamilyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUpdateFamily({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Device
 */
export const adminCreateDeviceMutation = (options?: Partial<Options<AdminCreateDeviceData>>): UseMutationOptions<AdminCreateDeviceResponse, AdminCreateDeviceError, Options<AdminCreateDeviceData>> => {
    const mutationOptions: UseMutationOptions<AdminCreateDeviceResponse, AdminCreateDeviceError, Options<AdminCreateDeviceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminCreateDevice({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Device
 */
export const adminDeleteDeviceMutation = (options?: Partial<Options<AdminDeleteDeviceData>>): UseMutationOptions<AdminDeleteDeviceResponse, AdminDeleteDeviceError, Options<AdminDeleteDeviceData>> => {
    const mutationOptions: UseMutationOptions<AdminDeleteDeviceResponse, AdminDeleteDeviceError, Options<AdminDeleteDeviceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminDeleteDevice({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminDeviceDetailQueryKey = (options: Options<AdminDeviceDetailData>) => createQueryKey('adminDeviceDetail', options);

/**
 * Device Detail
 */
export const adminDeviceDetailOptions = (options: Options<AdminDeviceDetailData>) => queryOptions<AdminDeviceDetailResponse, AdminDeviceDetailError, AdminDeviceDetailResponse, ReturnType<typeof adminDeviceDetailQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminDeviceDetail({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminDeviceDetailQueryKey(options)
});

/**
 * Update Device
 */
export const adminUpdateDeviceMutation = (options?: Partial<Options<AdminUpdateDeviceData>>): UseMutationOptions<AdminUpdateDeviceResponse, AdminUpdateDeviceError, Options<AdminUpdateDeviceData>> => {
    const mutationOptions: UseMutationOptions<AdminUpdateDeviceResponse, AdminUpdateDeviceError, Options<AdminUpdateDeviceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUpdateDevice({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Parent
 */
export const adminCreateParentMutation = (options?: Partial<Options<AdminCreateParentData>>): UseMutationOptions<AdminCreateParentResponse, AdminCreateParentError, Options<AdminCreateParentData>> => {
    const mutationOptions: UseMutationOptions<AdminCreateParentResponse, AdminCreateParentError, Options<AdminCreateParentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminCreateParent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Parent
 */
export const adminDeleteParentMutation = (options?: Partial<Options<AdminDeleteParentData>>): UseMutationOptions<AdminDeleteParentResponse, AdminDeleteParentError, Options<AdminDeleteParentData>> => {
    const mutationOptions: UseMutationOptions<AdminDeleteParentResponse, AdminDeleteParentError, Options<AdminDeleteParentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminDeleteParent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Parent
 */
export const adminUpdateParentMutation = (options?: Partial<Options<AdminUpdateParentData>>): UseMutationOptions<AdminUpdateParentResponse, AdminUpdateParentError, Options<AdminUpdateParentData>> => {
    const mutationOptions: UseMutationOptions<AdminUpdateParentResponse, AdminUpdateParentError, Options<AdminUpdateParentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUpdateParent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminListModuleRegistryQueryKey = (options?: Options<AdminListModuleRegistryData>) => createQueryKey('adminListModuleRegistry', options);

/**
 * List Module Registry
 */
export const adminListModuleRegistryOptions = (options?: Options<AdminListModuleRegistryData>) => queryOptions<AdminListModuleRegistryResponse, AdminListModuleRegistryError, AdminListModuleRegistryResponse, ReturnType<typeof adminListModuleRegistryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminListModuleRegistry({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminListModuleRegistryQueryKey(options)
});

export const adminScreenshotImageQueryKey = (options: Options<AdminScreenshotImageData>) => createQueryKey('adminScreenshotImage', options);

/**
 * Screenshot Image
 */
export const adminScreenshotImageOptions = (options: Options<AdminScreenshotImageData>) => queryOptions<unknown, AdminScreenshotImageError, unknown, ReturnType<typeof adminScreenshotImageQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminScreenshotImage({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminScreenshotImageQueryKey(options)
});

export const adminWindowCaptureQueryKey = (options: Options<AdminWindowCaptureData>) => createQueryKey('adminWindowCapture', options);

/**
 * Window Capture
 */
export const adminWindowCaptureOptions = (options: Options<AdminWindowCaptureData>) => queryOptions<AdminWindowCaptureResponse, AdminWindowCaptureError, AdminWindowCaptureResponse, ReturnType<typeof adminWindowCaptureQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminWindowCapture({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminWindowCaptureQueryKey(options)
});

export const deviceAgentBundleQueryKey = (options: Options<DeviceAgentBundleData>) => createQueryKey('deviceAgentBundle', options);

/**
 * Agent Bundle
 */
export const deviceAgentBundleOptions = (options: Options<DeviceAgentBundleData>) => queryOptions<unknown, DeviceAgentBundleError, unknown, ReturnType<typeof deviceAgentBundleQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await deviceAgentBundle({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: deviceAgentBundleQueryKey(options)
});

export const deviceExtensionUpdatesXmlQueryKey = (options?: Options<DeviceExtensionUpdatesXmlData>) => createQueryKey('deviceExtensionUpdatesXml', options);

/**
 * Extension Updates Xml
 */
export const deviceExtensionUpdatesXmlOptions = (options?: Options<DeviceExtensionUpdatesXmlData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof deviceExtensionUpdatesXmlQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await deviceExtensionUpdatesXml({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: deviceExtensionUpdatesXmlQueryKey(options)
});

export const deviceExtensionCrxQueryKey = (options: Options<DeviceExtensionCrxData>) => createQueryKey('deviceExtensionCrx', options);

/**
 * Extension Crx
 */
export const deviceExtensionCrxOptions = (options: Options<DeviceExtensionCrxData>) => queryOptions<unknown, DeviceExtensionCrxError, unknown, ReturnType<typeof deviceExtensionCrxQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await deviceExtensionCrx({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: deviceExtensionCrxQueryKey(options)
});

/**
 * Heartbeat
 */
export const deviceHeartbeatMutation = (options?: Partial<Options<DeviceHeartbeatData>>): UseMutationOptions<DeviceHeartbeatResponse, DeviceHeartbeatError, Options<DeviceHeartbeatData>> => {
    const mutationOptions: UseMutationOptions<DeviceHeartbeatResponse, DeviceHeartbeatError, Options<DeviceHeartbeatData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deviceHeartbeat({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Captures Upload
 */
export const deviceCapturesUploadMutation = (options?: Partial<Options<DeviceCapturesUploadData>>): UseMutationOptions<unknown, DeviceCapturesUploadError, Options<DeviceCapturesUploadData>> => {
    const mutationOptions: UseMutationOptions<unknown, DeviceCapturesUploadError, Options<DeviceCapturesUploadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deviceCapturesUpload({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const parentReadDevicesQueryKey = (options?: Options<ParentReadDevicesData>) => createQueryKey('parentReadDevices', options);

/**
 * Devices
 */
export const parentReadDevicesOptions = (options?: Options<ParentReadDevicesData>) => queryOptions<ParentReadDevicesResponse, ParentReadDevicesError, ParentReadDevicesResponse, ReturnType<typeof parentReadDevicesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await parentReadDevices({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: parentReadDevicesQueryKey(options)
});

export const parentReadDeviceDetailQueryKey = (options: Options<ParentReadDeviceDetailData>) => createQueryKey('parentReadDeviceDetail', options);

/**
 * Device Detail
 */
export const parentReadDeviceDetailOptions = (options: Options<ParentReadDeviceDetailData>) => queryOptions<ParentReadDeviceDetailResponse, ParentReadDeviceDetailError, ParentReadDeviceDetailResponse, ReturnType<typeof parentReadDeviceDetailQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await parentReadDeviceDetail({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: parentReadDeviceDetailQueryKey(options)
});

export const parentRulesListQueryKey = (options: Options<ParentRulesListData>) => createQueryKey('parentRulesList', options);

/**
 * List
 */
export const parentRulesListOptions = (options: Options<ParentRulesListData>) => queryOptions<ParentRulesListResponse, ParentRulesListError, ParentRulesListResponse, ReturnType<typeof parentRulesListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await parentRulesList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: parentRulesListQueryKey(options)
});

/**
 * Generate
 */
export const parentRulesGenerateMutation = (options?: Partial<Options<ParentRulesGenerateData>>): UseMutationOptions<ParentRulesGenerateResponse, ParentRulesGenerateError, Options<ParentRulesGenerateData>> => {
    const mutationOptions: UseMutationOptions<ParentRulesGenerateResponse, ParentRulesGenerateError, Options<ParentRulesGenerateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await parentRulesGenerate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete
 */
export const parentRulesDeleteMutation = (options?: Partial<Options<ParentRulesDeleteData>>): UseMutationOptions<ParentRulesDeleteResponse, ParentRulesDeleteError, Options<ParentRulesDeleteData>> => {
    const mutationOptions: UseMutationOptions<ParentRulesDeleteResponse, ParentRulesDeleteError, Options<ParentRulesDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await parentRulesDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const parentRulesReadQueryKey = (options: Options<ParentRulesReadData>) => createQueryKey('parentRulesRead', options);

/**
 * Read
 */
export const parentRulesReadOptions = (options: Options<ParentRulesReadData>) => queryOptions<ParentRulesReadResponse, ParentRulesReadError, ParentRulesReadResponse, ReturnType<typeof parentRulesReadQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await parentRulesRead({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: parentRulesReadQueryKey(options)
});

/**
 * Confirm
 */
export const parentRulesConfirmMutation = (options?: Partial<Options<ParentRulesConfirmData>>): UseMutationOptions<ParentRulesConfirmResponse, ParentRulesConfirmError, Options<ParentRulesConfirmData>> => {
    const mutationOptions: UseMutationOptions<ParentRulesConfirmResponse, ParentRulesConfirmError, Options<ParentRulesConfirmData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await parentRulesConfirm({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Set Enabled
 */
export const parentRulesSetEnabledMutation = (options?: Partial<Options<ParentRulesSetEnabledData>>): UseMutationOptions<ParentRulesSetEnabledResponse, ParentRulesSetEnabledError, Options<ParentRulesSetEnabledData>> => {
    const mutationOptions: UseMutationOptions<ParentRulesSetEnabledResponse, ParentRulesSetEnabledError, Options<ParentRulesSetEnabledData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await parentRulesSetEnabled({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const parentReadDeviceScreenshotsQueryKey = (options: Options<ParentReadDeviceScreenshotsData>) => createQueryKey('parentReadDeviceScreenshots', options);

/**
 * Device Screenshots
 */
export const parentReadDeviceScreenshotsOptions = (options: Options<ParentReadDeviceScreenshotsData>) => queryOptions<ParentReadDeviceScreenshotsResponse, ParentReadDeviceScreenshotsError, ParentReadDeviceScreenshotsResponse, ReturnType<typeof parentReadDeviceScreenshotsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await parentReadDeviceScreenshots({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: parentReadDeviceScreenshotsQueryKey(options)
});

export const parentReadDeviceScreenshotsInfiniteQueryKey = (options: Options<ParentReadDeviceScreenshotsData>): QueryKey<Options<ParentReadDeviceScreenshotsData>> => createQueryKey('parentReadDeviceScreenshots', options, true);

/**
 * Device Screenshots
 */
export const parentReadDeviceScreenshotsInfiniteOptions = (options: Options<ParentReadDeviceScreenshotsData>) => infiniteQueryOptions<ParentReadDeviceScreenshotsResponse, ParentReadDeviceScreenshotsError, InfiniteData<ParentReadDeviceScreenshotsResponse>, QueryKey<Options<ParentReadDeviceScreenshotsData>>, number | Pick<QueryKey<Options<ParentReadDeviceScreenshotsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ParentReadDeviceScreenshotsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                offset: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await parentReadDeviceScreenshots({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: parentReadDeviceScreenshotsInfiniteQueryKey(options)
});

export const deviceDeviceCaptureV2ConfigQueryKey = (options: Options<DeviceDeviceCaptureV2ConfigData>) => createQueryKey('deviceDeviceCaptureV2Config', options);

/**
 * Device Capture V2 Config
 */
export const deviceDeviceCaptureV2ConfigOptions = (options: Options<DeviceDeviceCaptureV2ConfigData>) => queryOptions<unknown, DeviceDeviceCaptureV2ConfigError, unknown, ReturnType<typeof deviceDeviceCaptureV2ConfigQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await deviceDeviceCaptureV2Config({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: deviceDeviceCaptureV2ConfigQueryKey(options)
});

export const deviceDeviceConfigQueryKey = (options: Options<DeviceDeviceConfigData>) => createQueryKey('deviceDeviceConfig', options);

/**
 * Device Config
 */
export const deviceDeviceConfigOptions = (options: Options<DeviceDeviceConfigData>) => queryOptions<unknown, DeviceDeviceConfigError, unknown, ReturnType<typeof deviceDeviceConfigQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await deviceDeviceConfig({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: deviceDeviceConfigQueryKey(options)
});

export const deviceDownloadFileQueryKey = (options: Options<DeviceDownloadFileData>) => createQueryKey('deviceDownloadFile', options);

/**
 * Download File
 */
export const deviceDownloadFileOptions = (options: Options<DeviceDownloadFileData>) => queryOptions<unknown, DeviceDownloadFileError, unknown, ReturnType<typeof deviceDownloadFileQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await deviceDownloadFile({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: deviceDownloadFileQueryKey(options)
});

export const parentReadFamilyQueryKey = (options?: Options<ParentReadFamilyData>) => createQueryKey('parentReadFamily', options);

/**
 * Family
 */
export const parentReadFamilyOptions = (options?: Options<ParentReadFamilyData>) => queryOptions<ParentReadFamilyResponse, ParentReadFamilyError, ParentReadFamilyResponse, ReturnType<typeof parentReadFamilyQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await parentReadFamily({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: parentReadFamilyQueryKey(options)
});

export const metaHealthQueryKey = (options?: Options<MetaHealthData>) => createQueryKey('metaHealth', options);

/**
 * Health
 */
export const metaHealthOptions = (options?: Options<MetaHealthData>) => queryOptions<MetaHealthResponse, DefaultError, MetaHealthResponse, ReturnType<typeof metaHealthQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await metaHealth({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: metaHealthQueryKey(options)
});

/**
 * Login
 */
export const parentAuthLoginMutation = (options?: Partial<Options<ParentAuthLoginData>>): UseMutationOptions<ParentAuthLoginResponse, ParentAuthLoginError, Options<ParentAuthLoginData>> => {
    const mutationOptions: UseMutationOptions<ParentAuthLoginResponse, ParentAuthLoginError, Options<ParentAuthLoginData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await parentAuthLogin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Logout
 */
export const parentAuthLogoutMutation = (options?: Partial<Options<ParentAuthLogoutData>>): UseMutationOptions<ParentAuthLogoutResponse, DefaultError, Options<ParentAuthLogoutData>> => {
    const mutationOptions: UseMutationOptions<ParentAuthLogoutResponse, DefaultError, Options<ParentAuthLogoutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await parentAuthLogout({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const parentAuthMeQueryKey = (options?: Options<ParentAuthMeData>) => createQueryKey('parentAuthMe', options);

/**
 * Me
 */
export const parentAuthMeOptions = (options?: Options<ParentAuthMeData>) => queryOptions<ParentAuthMeResponse, ParentAuthMeError, ParentAuthMeResponse, ReturnType<typeof parentAuthMeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await parentAuthMe({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: parentAuthMeQueryKey(options)
});

/**
 * Screenshots Live
 */
export const deviceScreenshotsLiveMutation = (options?: Partial<Options<DeviceScreenshotsLiveData>>): UseMutationOptions<unknown, DefaultError, Options<DeviceScreenshotsLiveData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DeviceScreenshotsLiveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deviceScreenshotsLive({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Screenshots Upload
 */
export const deviceScreenshotsUploadMutation = (options?: Partial<Options<DeviceScreenshotsUploadData>>): UseMutationOptions<unknown, DefaultError, Options<DeviceScreenshotsUploadData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DeviceScreenshotsUploadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deviceScreenshotsUpload({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const parentReadScreenshotImageQueryKey = (options: Options<ParentReadScreenshotImageData>) => createQueryKey('parentReadScreenshotImage', options);

/**
 * Screenshot Image
 */
export const parentReadScreenshotImageOptions = (options: Options<ParentReadScreenshotImageData>) => queryOptions<unknown, ParentReadScreenshotImageError, unknown, ReturnType<typeof parentReadScreenshotImageQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await parentReadScreenshotImage({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: parentReadScreenshotImageQueryKey(options)
});

export const parentReadScreenshotThumbnailQueryKey = (options: Options<ParentReadScreenshotThumbnailData>) => createQueryKey('parentReadScreenshotThumbnail', options);

/**
 * Screenshot Thumbnail
 */
export const parentReadScreenshotThumbnailOptions = (options: Options<ParentReadScreenshotThumbnailData>) => queryOptions<unknown, ParentReadScreenshotThumbnailError, unknown, ReturnType<typeof parentReadScreenshotThumbnailQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await parentReadScreenshotThumbnail({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: parentReadScreenshotThumbnailQueryKey(options)
});
